// The recovery code is handed to the user exactly once, on the page right after
// it is generated. It lives in sessionStorage only for that hop — never in
// localStorage, never in IDB, and it is cleared as soon as the user acknowledges.

const CODE_KEY = 'pv:recoveryCode';
const REASON_KEY = 'pv:recoveryCodeReason';

/** Why we are showing a code — drives the copy on RecoveryCodePage. */
export type RecoveryCodeReason = 'signup' | 'rotated' | 'recovered';

export interface StashedRecoveryCode {
  code: string;
  reason: RecoveryCodeReason;
}

/**
 * Only ever call this AFTER the server has accepted the new material. Stashing
 * first would show the user a code that was never persisted.
 */
export function stashRecoveryCode(code: string, reason: RecoveryCodeReason): void {
  sessionStorage.setItem(CODE_KEY, code);
  sessionStorage.setItem(REASON_KEY, reason);
}

export function readRecoveryCode(): StashedRecoveryCode | null {
  const code = sessionStorage.getItem(CODE_KEY);
  if (!code) return null;
  const stored = sessionStorage.getItem(REASON_KEY);
  const reason: RecoveryCodeReason =
    stored === 'rotated' || stored === 'recovered' ? stored : 'signup';
  return { code, reason };
}

export function clearRecoveryCode(): void {
  sessionStorage.removeItem(CODE_KEY);
  sessionStorage.removeItem(REASON_KEY);
}
